import { MONTH_NAMES, periodYears, periodLabel } from "@/lib/finance";

const selCls = "mt-1 block h-10 rounded-md border border-slate-300 bg-white px-2 text-sm text-slate-900";

function MonthYear({ label, value, onChange, testid }) {
  const [y, m] = value.split("-");
  return (
    <div className="text-xs font-semibold text-slate-500">
      {label}
      <div className="flex gap-2">
        <select value={m} onChange={(e) => onChange(`${y}-${e.target.value}`)} className={selCls} data-testid={`${testid}-month`}>
          {MONTH_NAMES.map((n, i) => <option key={n} value={String(i + 1).padStart(2, "0")}>{n}</option>)}
        </select>
        <select value={y} onChange={(e) => onChange(`${e.target.value}-${m}`)} className={selCls} data-testid={`${testid}-year`}>
          {periodYears().map((yr) => <option key={yr} value={yr}>{yr}</option>)}
        </select>
      </div>
    </div>
  );
}

export function GcPeriodPicker({ period, onChange }) {
  const set = (k) => (v) => {
    const next = { ...period, [k]: v };
    if (next.from > next.to) next[k === "from" ? "to" : "from"] = v;
    onChange(next);
  };
  return (
    <div className="no-print mb-4 flex flex-wrap items-end gap-4 rounded-xl border border-slate-200 bg-white p-4 text-slate-900" data-testid="gc-period-picker">
      <div className="text-sm font-semibold">Financial report period:</div>
      <MonthYear label="From" value={period.from} onChange={set("from")} testid="gc-period-from" />
      <MonthYear label="To" value={period.to} onChange={set("to")} testid="gc-period-to" />
      <span className="text-sm text-slate-600" data-testid="gc-period-label">{periodLabel(period)}</span>
    </div>
  );
}
